export default __webpack_public_path__ + "static/media/zefi.09c88a4a.png";